import { Routes, Route } from 'react-router-dom-v5-compat';
import { ModalContextProvider } from 'utils/contexts/modal';
import CreatePredictiveGoalPage from 'modules/predictiveGoals/components/upsert/create/CreatePredictiveGoalPage';
import { ReadOnlyGoalPage } from 'modules/predictiveGoals/components/ReadOnlyGoalPage';
import { PredictiveGoalsIndexPage } from 'modules/predictiveGoals/components/index/PredictiveGoalsIndexPage';
import { PredictiveGoalsProvider } from 'modules/predictiveGoals/components/contexts/PredictiveGoalsContext/PredictiveGoalsProvider';
import { CoreGoalsContextProvider } from 'modules/predictiveGoals/components/contexts/CoreGoalsContext/CoreGoalsContextProvider';
import { EditGoalPage } from '../upsert/edit/EditGoalPage';

export const PredictiveGoalsPages = () => {
  return (
    <ModalContextProvider>
      <CoreGoalsContextProvider>
        <PredictiveGoalsProvider>
          <Routes>
            <Route path="/goals/create" element={<CreatePredictiveGoalPage />} />
            <Route path="/goals/:goalId" element={<ReadOnlyGoalPage />} />
            <Route path="/goals/:goalId/edit" element={<EditGoalPage />} />
            <Route path="/" element={<PredictiveGoalsIndexPage />} />
          </Routes>
        </PredictiveGoalsProvider>
      </CoreGoalsContextProvider>
    </ModalContextProvider>
  );
};
